import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

const Slider = () => {
    const images = [
        "/Blockfarm/hosting/hostingimg.svg",
        "/Blockfarm/hosting/Hostingindex2.jpg",
    ];

    return (
        <Swiper
            modules={[Autoplay, Pagination]}
            spaceBetween={50}
            slidesPerView={1}
            pagination={{ clickable: true }}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            style={{ "--swiper-pagination-color": "var(--darkness)" }}
        >
            {images.map((image, index) => (
                <SwiperSlide key={index}>
                    <div className='flex justify-end'>
                        <img className='z-[500] w-full h-fit' src={image} alt={`Slide ${index + 1}`} />
                    </div>
                </SwiperSlide>
            ))}
        </Swiper>
    );
}

export default Slider;


